// extracted by mini-css-extract-plugin
export var container = "_cs-0";
export var infoIcon = "_cs-2";
export var titleRowCol = "_cs-1";